export enum ProcessState {
    waiting = 'waiting',
    processing = 'running',
    success = 'completed',
    fail = 'failed'
}
